var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdficon = function SvgPdficon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.296 0h9.6a1.6 1.6 0 0 1 1.6 1.6v8.608a2.4 2.4 0 0 1-.704 1.696L10.4 15.296A2.4 2.4 0 0 1 8.704 16H3.296a1.6 1.6 0 0 1-1.6-1.6V1.6a1.6 1.6 0 0 1 1.6-1.6Zm9.6 1.6h-9.6v12.8h4.8v-4a.8.8 0 0 1 .8-.8h4v-8Z",
    clipRule: "evenodd"
  })));
};
export default SvgPdficon;